import { computed, ref } from "@vue/composition-api";
import { debounce } from "lodash-es";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";

export default function useCheckUsername(allowEmptyName: boolean = false) {
  const { authUser } = useAuthUser();
  const processingUsername = ref(false);
  const isValidOlecamsNick = ref(true);
  const isValidOlefansScreenName = ref(true);

  const isValidScreenName = computed(() => isValidOlecamsNick.value && isValidOlefansScreenName.value);

  const checkOlecamsUsername = async (value: string) => {
    isValidOlecamsNick.value = await providers.OlecamsLoginProvider.checkUsername(value);
  };

  const checkOlefansScreenName = async (value: string) => {
    const response = await providers.UserPublicDataProvider.search(
      {
        data: { screenNames: [value] },
      },
      ["id", "screenName"]
    );
    isValidOlefansScreenName.value = response.totalRecords === 0;
  };

  const checkUsername = debounce(async (screenName: string | null | undefined) => {
    if (!screenName) {
      isValidOlecamsNick.value = isValidOlefansScreenName.value = allowEmptyName;
      return;
    }
    if (authUser.value && screenName === authUser.value.screenName) {
      isValidOlecamsNick.value = isValidOlefansScreenName.value = true;
      return;
    }
    try {
      isValidOlecamsNick.value = true;
      isValidOlefansScreenName.value = true;
      processingUsername.value = true;
      await Promise.all([checkOlecamsUsername(screenName), checkOlefansScreenName(screenName)]);
    } catch (e) {
      isValidOlecamsNick.value = false;
    } finally {
      processingUsername.value = false;
    }
  }, 500);

  return {
    isValidOlecamsNick,
    isValidOlefansScreenName,
    isValidScreenName,
    checkUsername,
    processingUsername,
  };
}
